const EmptyRouterView = () => /* webpackChunkName: "EmptyRouterView" */ import("./../views/samu/EmptyRouterView.vue");
const Home = () => /* webpackChunkName: "Home" */ import("./../views/samu/Home.vue");
const ManageCalls = () => /* webpackChunkName: "ManageCalls" */ import("./../views/samu/ManageCalls.vue");
const ManageAmbulance = () => /* webpackChunkName: "ManageAmbulance" */ import("./../views/samu/ManageAmbulance.vue");
const ManageUsers = () => /* webpackChunkName: "ManageUsers" */ import("./../views/samu/ManageUsers.vue");
const ManageEmployees = () => /* webpackChunkName: "ManageEmployees" */ import("./../views/samu/ManageEmployees.vue");
const ManageTurns = () => /* webpackChunkName: "ManageTurns" */ import("./../views/samu/ManageTurns.vue");
const ManagePatient = () => /* webpackChunkName: "ManagePatients" */ import("./../views/samu/ManagePatients.vue");
const IncidencesMap = () => /* webpackChunkName: "IncidencesMap" */ import("./../views/samu/IncidencesMap.vue");
const Document = () => /* webpackChunkName: "Document" */ import("@/views/general/Document.vue");

export const routes = [
  {
    path: "/samu",
    component: EmptyRouterView,
    children: [
      {
        path: "",
        name: "samuHome",
        component: Home,
      },
      {
        path: "samu-gestion-llamadas",
        name: "samuManageCalls",
        component: ManageCalls,
      },
      {
        path: "samu-gestion-ambulancias",
        name: "samuManageAmbulances",
        component: ManageAmbulance,
      },
      {
        path: "samu-gestion-usuarios",
        name: "samuManageUsers",
        component: ManageUsers,
      },
      {
        path: "samu-gestion-funcionarios",
        name: "samuManageEmployees",
        component: ManageEmployees,
      },
      {
        path: "samu-gestion-turnos",
        name: "samuManageTurns",
        component: ManageTurns,
      },
      {
        path: "samu-informacion-pacientes",
        name: "samuPatients",
        component: ManagePatient,
      },
      {
        path: "samu-mapa-incidencias",
        name: "samuIncidencesMap",
        component: IncidencesMap,
      },
      {
        path: "documentacion",
        name: "samuDocumentation",
        component: Document,
      },
    ],
  },
];
